import React from "react";
import { useTranslation } from "react-i18next";

export const PhoneStatusBar = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.composeMessage",
  });

  return (
    <div
      data-testid="phone-status-bar"
      className="relative flex items-center justify-between px-6 pt-5 pb-1"
    >
      <span className="text-sm font-semibold text-black">{t("phoneTime")}</span>

      <div className="absolute top-4 left-1/2 h-5 w-24 -translate-x-1/2 transform rounded-full bg-black"></div>

      <div className="flex items-center space-x-1">
        <div
          className="flex items-end space-x-0.5"
          data-testid="signal-strength"
        >
          <div className="h-1 w-1 rounded-full bg-black"></div>
          <div className="h-1.5 w-1 rounded-full bg-black"></div>
          <div className="h-2 w-1 rounded-full bg-black"></div>
          <div className="h-2.5 w-1 rounded-full bg-black"></div>
        </div>
        <div className="ml-1">
          <svg className="h-4 w-4 fill-black" viewBox="0 0 24 24">
            <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.07 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" />
          </svg>
        </div>
        <div
          className="relative ml-1 flex h-3 w-5 items-center rounded-sm border border-gray-300"
          data-testid="battery-container"
        >
          <div
            className="m-0.5 h-1.5 w-[100%] rounded-xs bg-primary"
            data-testid="battery-fill"
          ></div>
          <div
            className="absolute -right-1.25 h-1.25 w-0.75 rounded-r-sm bg-gray-300"
            data-testid="battery-nub"
          ></div>
        </div>
      </div>
    </div>
  );
};
